"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
var Tab_1 = __importDefault(require("@material-ui/core/Tab"));
var ErrorRounded_1 = __importDefault(require("@material-ui/icons/ErrorRounded"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return styles_1.createStyles({
        root: {
            maxWidth: 880,
            width: '100%',
            marginRight: 'auto',
            marginLeft: 'auto',
            marginBottom: theme.spacing(2),
        },
        tab: {
            margin: '0 2px',
            boxShadow: theme.shadows[1],
            backgroundColor: '#bcbec0',
            borderRadius: '.5rem .5rem 0 0',
            padding: theme.spacing(1, 2),
            minWidth: 0,
            textTransform: 'none',
            fontSize: '18px',
            alignItems: 'center',
        },
        tabInner: {
            display: 'flex',
            alignItems: 'center',
        },
        tabSelected: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            zIndex: 1,
            boxShadow: theme.shadows[8],
        },
        tabsIndicator: {
            display: 'none',
        },
        tabsScroller: {
            paddingTop: 12,
        },
        secondaryAction: {
            position: 'absolute',
            right: 0,
        },
        paper: (_a = {
                padding: theme.spacing(3),
                borderRadius: 8
            },
            _a[theme.breakpoints.down('xs')] = {
                borderRadius: 0,
            },
            _a),
        errorIcon: {
            color: theme.palette.error.dark,
            marginLeft: theme.spacing(1),
        },
    });
});
var CardEditorLayout = function (_a) {
    var answerError = _a.answerError, classNameProp = _a.className, children = _a.children, _b = _a.disableTabs, disableTabs = _b === void 0 ? false : _b, onChangeView = _a.onChangeView, questionError = _a.questionError, secondaryAction = _a.secondaryAction, view = _a.view, other = __rest(_a, ["answerError", "className", "children", "disableTabs", "onChangeView", "questionError", "secondaryAction", "view"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(Tabs_1.default, { centered: true, value: view, onChange: onChangeView, classes: {
                indicator: classes.tabsIndicator,
                scroller: classes.tabsScroller,
            } },
            react_1.default.createElement(Tab_1.default, { disableRipple: true, value: "question", disabled: disableTabs, label: react_1.default.createElement("span", { className: classes.tabInner },
                    "Question",
                    questionError && (react_1.default.createElement(ErrorRounded_1.default, { "aria-label": "Question error", className: classes.errorIcon }))), classes: { root: classes.tab, selected: classes.tabSelected } }),
            react_1.default.createElement(Tab_1.default, { disableRipple: true, value: "answer", disabled: disableTabs, label: react_1.default.createElement("span", { className: classes.tabInner },
                    "Answer",
                    answerError && (react_1.default.createElement(ErrorRounded_1.default, { "aria-label": "Answer error", className: classes.errorIcon }))), classes: { root: classes.tab, selected: classes.tabSelected } }),
            react_1.default.createElement(Tab_1.default, { disableRipple: true, value: "preview", label: "Preview", disabled: disableTabs, classes: { root: classes.tab, selected: classes.tabSelected } }),
            react_1.default.createElement("div", { className: classes.secondaryAction }, secondaryAction)),
        react_1.default.createElement(Paper_1.default, { elevation: 6, className: classes.paper }, children)));
};
exports.default = CardEditorLayout;
//# sourceMappingURL=CardEditorLayout.js.map